import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  user: state.user.user,
  userInfo: state.user.loyaltyStatistics,
  pets: state.pet.userPets,
});

angular
  .module('myConsultApp')
  .controller(
    'userDetailController',
    ($compile, $location, $ngRedux, $scope, $rootScope, $http, ENV, $interval, $timeout) => {
      $scope.applications_list = [];
      $scope.invite_list = [];
      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.getInviteList = async (applications) => {
        $scope.invite_list = [];
        await angular.forEach(applications, async (application) => {
          if (
            !application.name.toLowerCase().includes('pawpath') &&
            !application.name.toLowerCase().includes('proxy') &&
            !application.name.toLowerCase().includes('pro') &&
            !application.name.toLowerCase().includes('planner') &&
            !application.name.toLowerCase().includes('deprecated')
          ) {
            let application_found = false;
            await angular.forEach($scope.user.applications, async (user_application) => {
              if (user_application.name === application.name) {
                application_found = true;
              }
            });
            if (!application_found) {
              $scope.invite_list.push({
                id: application.id,
                name: application.name,
                subject_text: '',
                body_text: '',
              });
            }
          }
        });
      };

      $scope.loadUserPage = () => {
        const delay = $scope.activeComponent ? $scope.toggleComponentAnimationDelay : 0;
        $timeout(() => {
          $rootScope.closeComponent().then(() => {
            const path = `${$rootScope.routes.user}/${$scope.user.id}`;
            $timeout(() => {
              $location.path(path, true);
            }, 1);
          });
        }, delay);
      };

      $scope.getApplications = async () => {
        $scope.getApplicationSubscriptions($http, ENV).then((res) => {
          $scope.$apply(async () => {
            $scope.applications_list = res;
            $scope.getInviteList(res);
          });
        });
      };

      $scope.getPoints = (userId) => {
        $scope.getLoyaltyStatistics($http, ENV, userId);
      };

      $scope.pushToSalesforce = (userId) => {
        $scope.pushUserToSalesforce($http, ENV, userId);
      };

      let promise;
      const userDetailListener = $scope.$watch('user', () => {
        if ($scope.user && $scope.user.id !== undefined) {
          if ($scope.user.applications && $scope.applications_list.length === 0) {
            $scope.getApplications();
          } else if ($scope.user.applications && $scope.applications_list.length > 0) {
            $scope.getInviteList($scope.applications_list);
          }
          // if promise exists, cancel it to prevent duplication of intervals
          if (angular.isDefined(promise)) {
            $interval.cancel(promise);
            promise = undefined;
          }
          promise = $interval(() => {
            $scope.getPoints($scope.user.id);
          }, 300000);
        } else {
          $scope.applications_list = [];
          $scope.invite_list = [];
          $scope.setUserPets([]);
          $scope.setActiveUserInfo({});
          $rootScope.userDetailExpanded = false;
          $interval.cancel(promise);
          promise = undefined;
        }
      });

      $scope.createModal = async (content) => {
        $scope.modalProcessing = false;
        angular.element(document.querySelector('.admin-overlay-modal')).remove();
        angular.element(document.querySelector('.admin-modal')).remove();
        let $body = $(content);
        let temp = $compile($body)($scope);
        await angular.element(document.body).append(temp);
        setTimeout(() => {
          angular.element(document.querySelector('.admin-modal')).addClass('display');
        }, 150);
      };

      const userProfileListener = (stop = false) => {
        let user1;
        let user2;
        if (!stop) {
          user1 = setTimeout(() => {
            $scope.getUser($http, ENV, $scope.user.id);
          }, 60000);
          user2 = setTimeout(() => {
            $scope.getUser($http, ENV, $scope.user.id);
          }, 120000);
        } else {
          clearTimeout(user1);
          clearTimeout(user2);
        }
      };

      $scope.init();
      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        $scope.applications_list = [];
        $scope.invite_list = [];
        $interval.cancel(promise);
        userDetailListener();
        userProfileListener(true);
      });
    },
  )
  .directive('userDetail', () => {
    return {
      templateUrl: 'templates/v2/user-detail.html',
    };
  });
